import { songs } from "../constants";
import { Song } from "../types/song";

export function searchSong(searchTerm: string, library: Song[] = songs): Song[] {
  searchTerm = searchTerm.toLowerCase();

  return library
    .filter((song: Song) => {
      const songName = song.name.toLowerCase();
      const songArtist = song.artist.toLowerCase();

      if (songArtist.includes(searchTerm) || songName.includes(searchTerm)) {
        return true;
      }

      return false;
    })
    .sort((a, b) =>
      a.artist.toLowerCase().localeCompare(b.artist.toLocaleLowerCase())
    )
    .slice(0, 5);
}
